import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { graphql } from 'gql';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

const uerWorkOrderChangeWorkRatioInfoGql = graphql(`
    query uerWorkOrderChangeWorkRatioInfo($workOrderId: Long!, $constructionTypeId: Int!) {
        uerWorkOrderChangeWorkRatioInfo(workOrderId: $workOrderId, constructionTypeId: $constructionTypeId) {
            result
            message
            data {
                hasEmptyWorkRatios
            }
        }
    }
`);

const requestId = 'workOrderChangeWorkRatioInfo';

export const useWorkOrderChangeWorkRatioInfo = ({
    workOrderChangeId,
    constructionTypeId,
}: {
    workOrderChangeId: number;
    constructionTypeId: number;
}) => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            workOrderId: workOrderChangeId,
            constructionTypeId,
        }),
        [workOrderChangeId, constructionTypeId],
    );

    const [data, , , request] = useRequest({
        query: uerWorkOrderChangeWorkRatioInfoGql,
        requestId,
        variables,
        withEffect: Boolean(workOrderChangeId && constructionTypeId),
    });

    const [reset] = useResetStoreData({
        requestId,
    });

    useEffect(
        () => () => {
            reset(undefined);
        },
        [reset],
    );

    const refreshWorkRatioInfo = useCallback(() => {
        dispatch(request(variables));
    }, [dispatch, request, variables]);

    const { hasEmptyWorkRatios = false } = data?.uerWorkOrderChangeWorkRatioInfo?.data || {};

    return {
        hasEmptyWorkRatios,
        refreshWorkRatioInfo,
    };
};
